import React from 'react'
import "../PercentageInputSign/PercentageInputSign.css"

function PercentageInputSign (props) {
    const {
        onChange,
        inputValue,
        placeholder,
        name,
        id,
        errorMsg = "Only numeric values are allowed",
        flag = false,
        maxLength = "12",
        containerStyle,
        disabled = false,
        labelIcon = "%",
        classN ="input-box",
        classE = "si_error_text"
      } = props;
    return (
        <div className="wrap-input percentage">
            <div className="container-input">
                <div className={classN}>
                    <input
                    id={id}
                    className="si_input border-rd-left"
                    // id="si_input"
                    type="text"
                    name={name}
                    value={inputValue}
                    placeholder={placeholder}
                    onChange={onChange}
                    maxLength={maxLength}
                    style={containerStyle}
                    disabled={disabled}
                    />
                     <label className="material-icons border-rd-left">{labelIcon}</label>
                </div>
                <p className={classE} style={{ display: flag ? "block" : "none" }}>
                        {errorMsg}
                </p>
            </div>
        </div>
    )
}


export default PercentageInputSign;